import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";
import React from "react";
import SendIcon from "@mui/icons-material/Send";

const CommentModal = ({
  commentModal,
  setComment,
  loading,
  comment,
  handleClose,
  handleSubmit,
  editingCommentId,
  editCommentText,
  setEditCommentText,
  handleSaveEditComment
}) => {

  console.log("Editing Comment ID:", editingCommentId);
  return (
    <Dialog
      open={commentModal}
      // onClose={handleClose}
      fullWidth
      maxWidth="md"
    >
      <DialogTitle>{`${editingCommentId ? "Edit" : "Add"} Comment Here...`}</DialogTitle>

      <DialogContent>
        <TextField
          autoFocus
          multiline
          minRows={4}
          fullWidth
          variant="outlined"
          label="Your Comment"
          value={editingCommentId ? editCommentText : comment}
          onChange={(e) => editingCommentId ? setEditCommentText(e.target.value) : setComment(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter" && !e.shiftKey) {
              e.preventDefault(); // prevent newline in input box
              setComment((prev) => prev + "\n");
            }
          }}
          sx={{ mt: 1 }}
        />
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose} variant="outlined">
          Cancel
        </Button>

        <Button
          variant="contained"
          color="primary"
          endIcon={!loading && <SendIcon />}
          onClick={handleSubmit}
          disabled={loading || (editingCommentId ? !editCommentText.trim() : !comment.trim())}
          sx={{ position: "relative" }}
        >
          {loading ? (
            <CircularProgress size={24} sx={{ color: "#fff" }} />
          ) : (
            editingCommentId ? "Update Comment" : "Add Comment"
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CommentModal;
